import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router';

interface ChangesFromInfoTagProps {
  fieldName: string;
  titleName?: string;
}

export interface ChangesFromInfoTagRef {
  hide: () => void;
}

export const ChangesFromInfoTag = ({ fieldName, titleName }: ChangesFromInfoTagProps) => {
  const location = useLocation();
  const fromScreenInfoConfig = location.state?.fromScreenInfoConfig;

  const shouldShowBadge =
    (fromScreenInfoConfig &&
      Array.isArray(fromScreenInfoConfig.messageFieldNames) &&
      fromScreenInfoConfig.messageFieldNames.includes(fieldName)) ||
    (fromScreenInfoConfig && titleName && fromScreenInfoConfig.messageTitleName === titleName);

  if (!shouldShowBadge) return null;

  return (
    <Box
      sx={theme => ({
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: Number(theme.shape.borderRadius) * 2,
        color: 'primary.main',
        padding: theme.spacing(0.5, 1.5),
        backgroundColor: 'primary.light',
        gap: theme.spacing(1),
      })}
      data-test={`changes-from-info-tag-${fieldName}`}
    >
      <AutoAwesomeOutlinedIcon fontSize="small" />
      <Typography
        variant="overline"
        sx={{
          fontWeight: 'fontWeightBold',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          fontSize: '11px',
        }}
      >
        {fromScreenInfoConfig.message}
      </Typography>
    </Box>
  );
};
